import React, { useState } from "react";
import { useGetTravelConfirmationByIdQuery } from "@graphql";
import { ErrorCard, Spinner } from "@common";
import { TravelConfirmationStore } from "@bookings/BookingHospitality/TravelConfirmation/TravelConfirmationStore";
import {
  TravelConfirmationFormData,
  mapDataToValues
} from "@bookings/BookingHospitality/TravelConfirmation/utils";
import { TravelConfirmationForm } from "@bookings/BookingHospitality/TravelConfirmation/TravelConfirmationForm";
import { useNavigation } from "@navigation";

type Props = {
  bookingId: string;
  confirmationId: string;
};

export const TravelConfirmationEditPage = (props: Props) => {
  const [formStore, setFormStore] = useState<TravelConfirmationStore>(null);
  const { loading, error } = useGetTravelConfirmationByIdQuery({
    variables: { bookingId: props.bookingId, confirmationId: props.confirmationId },
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      const initial: TravelConfirmationFormData = mapDataToValues(data);
      const store = new TravelConfirmationStore(
        props.confirmationId,
        props.bookingId,
        data.bookingById,
        initial
      );
      setFormStore(store);
    }
  });

  const nav = useNavigation();

  if (loading) {
    return <Spinner />;
  }

  if (error) {
    return <ErrorCard title="Cannot load item" message={error.message} />;
  }

  nav.lockNavigation("trav_conf", formStore?.form.dirty);

  return formStore && <TravelConfirmationForm isNew={false} formStore={formStore} />;
};
